import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, saveToken } from "../lib/api";
import { AriaOrb } from "../components/AriaOrb";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/login"); return; }
    const session_id = decodeURIComponent(m[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        saveToken(data.token);
        await checkAuth();
        // remove hash
        window.history.replaceState({}, "", "/app/chat");
        navigate("/app/chat");
      } catch (e) {
        navigate("/login");
      }
    })();
  }, [navigate, checkAuth]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[var(--aria-bg)] gap-4">
      <AriaOrb state="thinking" size={64} />
      <div className="text-sm text-[var(--aria-text-muted)]">Signing you in…</div>
    </div>
  );
}
